import { api } from "../client";
import { Config } from "../types";
import {
  ReceiverGroupFields,
  ReceiverGroupExtraFields,
  PartialReceiverGroupFields,
  PartialReceiverGroupExtraFields,
} from "../schema/ReceiverGroup";

type ApiRequestConfig = Config<ReceiverGroupFields, ReceiverGroupExtraFields>;
type ApiRequestConfigMutate = Config<
  PartialReceiverGroupFields,
  PartialReceiverGroupExtraFields
>;

export const getReceiverGroups = (config?: ApiRequestConfig) => {
  return api.get<ReceiverGroupFields, ReceiverGroupExtraFields>(
    `receiver_groups`,
    config
  );
};

export const getReceiverGroup = (id: number, config?: ApiRequestConfig) => {
  return api.get<ReceiverGroupFields, ReceiverGroupExtraFields>(
    `receiver_groups/${id}`,
    config
  );
};
